import { Types } from "../types";
export var assetTypeFragmentSchema = Types.enum(["article", "competition", "competitor", "fixture", "news", "program", "shop", "show", "sport", "subscription"]);
//# sourceMappingURL=assetTypeFragment.js.map